export default __webpack_public_path__ + "static/goods-1-23249c8a3be6f7be8d6b131421a99ffb.png";